import * as actionTypes from './actionTypes'
import { WS_CONNECT_FINISHED, WS_DISCONNECT_FINISHED } from '../../connectivity/interface/actionTypes'
import { handleActions } from 'redux-actions'

const reducers = {}

reducers[actionTypes.ENABLE_NOTIFICATION_CHANNEL_FINISH] = {
  next (state, action) {
    const channel = action.meta.channel
    const enabled = action.payload.channelEnabled

    let newChannelState
    if (enabled) {
      newChannelState = {
        ...state[channel],
        ...action.payload
      }
    } else {
      // If the channel is being disabled, clear old state.
      newChannelState = {
        ...action.payload
      }
    }

    return {
      ...state,
      [channel]: newChannelState
    }
  }
}

/*
 * The websocket channel is assumed to be enabled when the
 *      websocket is opened.
 */
reducers[WS_CONNECT_FINISHED] = {
  next (state) {
    // TODO: Link WS only?
    return {
      ...state,
      WEBSOCKET: {
        ...state.WEBSOCKET,
        channelEnabled: true
      }
    }
  }
}

/*
 * The websocket channel is assumed to be disabled when the
 *      websocket is closed.
 */
reducers[WS_DISCONNECT_FINISHED] = {
  next (state) {
    // TODO: Link WS only?
    return {
      ...state,
      WEBSOCKET: {
        ...state.WEBSOCKET,
        channelEnabled: false
      }
    }
  }
}

// Default notifications sub-state.
const defaultState = {
  WEBSOCKET: {
    channelEnabled: false
  },
  PUSH: {
    channelEnabled: true
  }
}

/**
 * Notifications reducer.
 * @method reducer
 * @param  {Object}  state - The current redux state.
 * @param  {Object}  action - A flux standard action.
 * @return {Object}  - The new redux state.
 */
const reducer = handleActions(reducers, defaultState)
export default reducer
